import '../styling/DashNav3.css'
import dash from '../resources/dashboard.png';
import clients from '../resources/clients.png';
import tape from '../resources/tape.png';
import invoice from '../resources/invoice.png';
import logoutimage from '../resources/logout.png';
import { Link } from "react-router-dom";
import {useLogout} from "../hooks/useLogout"

const DashNav3 = () => {
    
    const {logout} = useLogout();
    
    const handleClick = () => {
    logout();

    }

    const pointerStyle = {
        cursor: 'pointer'
    };

    return ( 
        <div className="dashnav3">
            
            <div className="dash3logo">
            <h1>InvoiceMaster Pro</h1>
            </div>
            <div className="divider"></div>

            <Link to="/dashboard" style={{textDecoration: 'none'}}>
            <div className="dash3navbox">
                <img src={dash} alt="dash" />
                <h1>Dashboard</h1>
            </div>
            </Link>

            
            <Link to="/clients" style={{textDecoration: 'none'}}>
            <div className="dash3clientsbox">
                <img src={clients} alt="dash" />
                <h1>Clients</h1>
            </div>
            </Link>

            <Link to="/quotes" style={{textDecoration: 'none'}}>
            <div className="dash3quotesbox">
                <img src={tape} alt="dash" />
                <h1>Quotes</h1>
            </div>
            </Link>

            <Link to="/invoices" style={{textDecoration: 'none'}}>
            <div className="dash3invoicebox">
                <img src={invoice} alt="dash" />
                <h1>Invoice</h1>
            </div>
            </Link>
            <a style={pointerStyle} onClick={handleClick} id="logoutthing">
            <div className="dash3logoutbox">
                <img src={logoutimage} alt="dash" />
                <h1>Logout</h1>
            </div>
            </a>
            
        </div>
    );
}
 
export default DashNav3;